
import Vue from 'vue';
import { ACTIONS } from '../constants/actions';
import AccountTabs from '../components/account/AccountTabs.vue';
import HomePageLayout from '../layouts/HomePageLayout.vue';
export default Vue.extend({
  components: { HomePageLayout, AccountTabs },
  name: 'Account',
  created(): void {
    this.getProfile();
    this.getAccountsBalance();
  },
  methods: {
    getProfile(): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.profile.getProfile);
    },
    getAccountsBalance(): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.accounts.getBalance);
    }
  }
});
